module.exports = __webpack_public_path__ + "img/mall4.f0b4b7ca.png";